var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96944 0.489239C3.87032 0.496326 3.77644 0.536425 3.70278 0.603129L0.14734 3.80303C0.103924 3.84206 0.0686211 3.88925 0.0434475 3.94193C0.0182739 3.9946 0.00372534 4.05172 0.000626578 4.11001C-0.00247218 4.16831 0.00594458 4.22665 0.0253925 4.28169C0.0448405 4.33673 0.074936 4.38741 0.113969 4.43082C0.153003 4.47423 0.200206 4.50953 0.252881 4.5347C0.305557 4.55986 0.362678 4.57441 0.420975 4.5775C0.479272 4.58059 0.537607 4.57217 0.592649 4.55272C0.647691 4.53326 0.698359 4.50316 0.741766 4.46412L4 1.53088L7.25823 4.46412C7.30164 4.50316 7.3523 4.53326 7.40735 4.55272C7.46239 4.57217 7.52072 4.58059 7.57902 4.5775C7.63732 4.57441 7.69444 4.55986 7.74711 4.5347C7.79979 4.50953 7.847 4.47423 7.88603 4.43082C7.92506 4.38741 7.95517 4.33673 7.97461 4.28169C7.99406 4.22665 8.00247 4.16831 7.99937 4.11001C7.99627 4.05172 7.98172 3.9946 7.95655 3.94193C7.93137 3.88925 7.89607 3.84206 7.85266 3.80303L4.29721 0.603129C4.25301 0.563136 4.20121 0.532443 4.1449 0.512877C4.08859 0.493312 4.02892 0.485273 3.96944 0.489239Z",
    fill: "#2B96DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.a0cce508837b38ba7ce56bcd88b49590.svg";
export { ForwardRef as ReactComponent };